export default class extends Controller {
  static targets = ["fileField", "uploadsTemplate"]

  connect() {
    this.replaceFileMaybe = this.replaceFileMaybe.bind(this)
    this.clearFileFieldMaybe = this.clearFileFieldMaybe.bind(this)
    addEventListener("direct-upload:start", this.initializePendingUploadComponent.bind(this))
    App.Helpers.listenToCustomEvent(document, "image-cropper:crop-complete", this.replaceFileMaybe)
    App.Helpers.listenToCustomEvent(document, "image-cropper:cancel", this.clearFileFieldMaybe)
  }

  initializePendingUploadComponent(event) {
    const { target, detail } = event
    const { id, file } = detail
    target.insertAdjacentHTML("beforebegin", this.pendingUploadTemplateFor(id, file.name))
  }

  pendingUploadTemplateFor(id, filename) {
    return this.uploadsTemplateTarget.innerHTML.replace(/UPLOAD_ID/g, id).replace(/UPLOAD_FILENAME/g, filename)
  }

  fileChange(event) {
    if (this.cropImage) {
      let file
      if (this.fileFieldTarget.files && this.fileFieldTarget.files[0]) {
        file = this.fileFieldTarget.files[0];
      }

      // only do something if a file is present
      // and is an image
      if (file && /^image/.test(file.type)) {
        var dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        dataTransfer.initiatingEntity = this
        App.ImageCropper.openImageCropper(dataTransfer)
      } else if(file && this.mustBeImage) {
        // If the file selected is not an image, alert the user and clear the file input
        alert("File must be an image.");
        this.fileFieldTarget.value = null
      }
    }
  }

  replaceFileMaybe(event) {
    const { dataTransfer } = event.detail
    if (dataTransfer && dataTransfer.initiatingEntity === this) {
      this.replaceFileInputFileWithCroppedImage(dataTransfer)
    }
  }

  clearFileFieldMaybe(event) {
    const { initiatingEntity } = event.detail
    if (initiatingEntity === this) {
      this.fileFieldTarget.value = null
    }
  }

  replaceFileInputFileWithCroppedImage(dataTransfer) {
    this.fileFieldTarget.files = dataTransfer.files
  }

  get cropImage() {
    return App.Helpers.isTruthy(this.data.get("crop-image"))
  }

  get mustBeImage() {
    return App.Helpers.isTruthy(this.data.get("must-be-image"))
  }
}



// WEBPACK FOOTER //
// ./app/components/file_uploads/assets/javascript/file-uploads-direct-upload-controller.js